import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Row, Col, Container } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { Button, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';

// helpers
import messages from '../../../../locale/messages';
import debounce from '../../../../helpers/debounce';
// components
import CustomPagination from '../../../CustomPagination/CustomPagination';
import Link from '../../../Link/Link';
import ConfirmationPopup from '../../../Common/ConfirmationPopup';
// images
import EditIcon from '../../../../../public/RestaurantIcon/edit.png';
import TrashIcon from '../../../../../public/RestaurantIcon/dlty.png';
import ManageItemIcon from '../../../../../public/RestaurantIcon/food-Item.png';
// redux action
import updateMenuStatus from '../../../../actions/shop/menu/updateMenuStatus';
import deleteMenu from '../../../../actions/shop/menu/deleteMenu';
import { openModal, closeModal } from '../../../../actions/siteadmin/modalActions';

// style
import s from './MenuList.css';
import rs from '../../../restaurantCommon.css';


class MenuList extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0
    }
    this.paginationData = this.paginationData.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
    this.handleStatus = this.handleStatus.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  handleKeywordSearch(searchList) { // Keyword search
    const { menuDetails: { refetch } } = this.props;
    this.setState({ searchList, currentPage: 1 });
    refetch({ currentPage: 1, searchList });
  }

  async handleDelete(id, currentPage) {
    const { deleteMenu, menuDetails: { refetch }, closeModal } = this.props;
    let variables = { currentPage };
    await deleteMenu(id, currentPage);
    await closeModal('menuDeleteModal')
    refetch(variables);
  };

  paginationData(currentPage) {

    const { menuDetails: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);

  };

  async handleStatus(id, status, currentPage) {
    const { updateMenuStatus, menuDetails: { refetch } } = this.props;
    let variables = { currentPage };
    await updateMenuStatus(id, status, currentPage);
    refetch(variables);
  };


  render() {
    const { menuDetails, openModal, closeModal, menuDeleteModal, modalData } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;

    return (
      <div className={'mainContainer'}>
        <div>
          <ConfirmationPopup
            modalStatus={menuDeleteModal}
            title={formatMessage(messages.deleteMenuTitle)}
            body={formatMessage(messages.deleteConfirmation)}
            closeModal={() => closeModal('menuDeleteModal')}
            popupButtonLeftName={formatMessage(messages.cancelButton)}
            popupButtonRightName={formatMessage(messages.deleteAction)}
            popupButtonLeftFunction={() => closeModal('menuDeleteModal')}
            popupButtonRightFunction={() => this.handleDelete(modalData.id, modalData.currentPage)}
          />
        </div>
        <Container fluid>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <h1 className={rs.restaurantTitleText}>{formatMessage(messages.manageMenu)}</h1>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className={cx(rs.searchInputRestaurant, s.verticalTopPad, s.floatLeft, 'floatRightRTL')}>
                <FormControl type='text' placeholder={formatMessage(messages.search)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={cx(rs.formControlInputRestaurant, rs.searchInputWidth)} />
              </div>
              <div className={cx(s.displayInlineBlock, rs.searchTopBtn, s.floatRight, 'floatLeftRTL', 'floatinhertRTL')}>
                <Link to={"/restaurant/menu/modifier-groups"} className={cx(rs.button, rs.btnPrimaryBorder, s.displayInlineBlock, s.modifierGroupBtn, 'groupBtnRight')}>{formatMessage(messages.modifierGroup)}</Link>
                <Link to={"/restaurant/menu/add"} className={cx(rs.button, rs.btnPrimary, s.displayInlineBlock)}>{formatMessage(messages.addMenu)}</Link>
              </div>
            </Col>
          </Row>
          {
            menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results && menuDetails.getAllMenu.results.length > 0 && menuDetails.getAllMenu.results.map((item, index) => {
              let getOpenDay = item.menuAvailability.filter(i => (i.isOpen == true));
              return (
                <Row key={index}>
                  <Col xs={12} lg={12} md={12} sm={12}>
                    <div className={cx(rs.menuItemGrid, s.paddingMenuGrid)}>
                      <div className={cx(s.menuInnerFlex, 'textAlignRightRTL')}>
                        <div>
                          <div className={cx(rs.alignLeft, rs.tabSection, 'textAlignRightRTL')}>
                            <p className={cx(rs.idTitle, rs.textOverFlow)}>
                              {item.menuName}
                            </p>
                          </div>
                        </div>

                        <div className={'restaurantActiveSelect'}>
                          <select value={item.isEnable} onChange={(e) => { this.handleStatus(item.id, e.target.value, currentPage) }} className={cx(rs.activeSelect, rs.restaurantSelectInput)}>
                            <option value={true}>{formatMessage(messages.active)}</option>
                            <option value={false}>{formatMessage(messages.inactive)}</option>
                          </select>
                        </div>

                        <div className={s.innerFlex2}>

                          <div className={s.menuButtonFlex}>
                            <Link to={'/restaurant/menu/edit/' + item.id} className={cx(rs.linkColor, s.linkButton)}>
                              <img src={EditIcon} className={cx(s.iconsWidth, 'iconsWidthRTL')} />
                              <span className={cx(rs.vtrMiddle, s.editSection)}>{formatMessage(messages.editItem)}</span>
                            </Link>
                            <Button className={cx(rs.deleteBtn, s.editBtn, s.IconLeft, rs.textOverFlow)} onClick={() => openModal('menuDeleteModal', { id: item.id, modalName: 'menuDeleteModal', currentPage })}>
                              <img src={TrashIcon} className={cx(s.iconsWidth, 'iconsWidthRTL', 'trashIconRTL')} />
                              <span className={rs.vtrMiddle}>{formatMessage(messages.deleteAction)}</span>
                            </Button>
                          </div>

                          <Link to={'/restaurant/menu/' + item.id + '/item'} className={cx(rs.button, rs.btnPrimary, rs.manageBtnFood, rs.manageBtn, s.marginNone)}>
                            <img src={ManageItemIcon} className={cx(s.iconsWidth, 'iconsWidthRTL')} />
                            <span className={rs.vtrMiddle}>{formatMessage(messages.manageItem)}</span>
                          </Link>
                        </div>
                      </div>

                      <div className={cx(rs.spaceTop5, rs.space2, rs.alignCenter, rs.activeDays)}>
                        <span className={s.activeDaysText}>
                          {formatMessage(messages.activeDays)}
                        </span>: {' '}
                        <span>
                          {
                            getOpenDay && getOpenDay.length > 0 ? getOpenDay.map(function (elem) {
                              return formatMessage(messages[elem.operationDay]);
                            }).join(", ") + '.' : formatMessage(messages.noActiveDays) + '.'
                          }
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              )
            })
          }
          {
            menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results && menuDetails.getAllMenu.results.length == 0 &&
            <span className={rs.notFoundText}><FormattedMessage {...messages.noMenu} />.</span>
          }
          {
            menuDetails && menuDetails.getAllMenu && menuDetails.getAllMenu.results && menuDetails.getAllMenu.results.length > 0
            && <div className={cx(s.space5, s.spaceTop5, 'restaurant')}>
              <CustomPagination
                total={menuDetails.getAllMenu.count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={formatMessage(messages.menus)}
              />
            </div>
          }
        </Container>
      </div>
    );
  }
}

const mapDispatch = {
  deleteMenu,
  updateMenuStatus,
  openModal,
  closeModal
};

const mapState = (state) => ({
  menuDeleteModal: state.modalStatus.menuDeleteModal,
  modalData: state.modalStatus.data && state.modalStatus.data[0],
});

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(MenuList)));